import Factory from './factory';

Object.assign(
  Factory.prototype
);

module.exports = new Factory();
